export enum KPI_STATS {
  CLICKS = 'clicks',
  CONVERSIONS = 'conversions',
  EVENTS = 'events',
}
